import React, { Component } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import { Typography } from "@mui/material";
import Shemsh from "../../static/icons/shemsh.png";
import Bilet from "../../static/icons/bilet.png";
import Nimkoreh from "../../static/icons/nimkoreh.png";

class Products extends Component {
  state = {};
  render() {
    const { handleComToShow } = this.props;
    return (
      <Grid item xs={12} mt={5}>
        <Grid container justifyContent="center" spacing={2.5}>
          {[
            {
              menuText: "شمش آلیاژی آلومینیوم",
              icon: Shemsh,
              compName: "shemsh",
            },
            {
              menuText: "بیلت آلیاژی آلومینیوم",
              icon: Bilet,
              compName: "bilet",
            },
            {
              menuText: "نیم کره آلومینیومی",
              icon: Nimkoreh,
              compName: "nimkoreh",
            },
          ].map((menuItem, index) => (
            <Grid key={index} item xs={4}>
              <div onClick={() => handleComToShow(menuItem.compName)}>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  spacing={0.5}
                >
                  <Avatar src={menuItem.icon} sx={{ width: 96, height: 96 }} />
                  <Typography variant="caption">{menuItem.menuText}</Typography>
                </Stack>
              </div>
            </Grid>
          ))}
        </Grid>
      </Grid>
    );
  }
}

export default Products;
